    import React from 'react';
    import Typography from '@material-ui/core/Typography';
    import Grid from '@material-ui/core/Grid';
    import TextField from '@material-ui/core/TextField';
    import FormControlLabel from '@material-ui/core/FormControlLabel';
    import Checkbox from '@material-ui/core/Checkbox';

    export default function AddressForm({auctionInfo, setAuctionInfo}) {
    return (
        <>
        <Typography variant="h6" gutterBottom>
            Address details
        </Typography>
        <Grid container spacing={3}>

            {/******************  DELIVERY DETAILS  ****************************/}
            <Grid item xs={12}>
            <Typography variant="body2">
            Pick Up Details
            </Typography>
                <TextField
                    required
                    value={auctionInfo.move_from_address}
                    id="move_from_address_id"
                    name="move_from_address"
                    label="Pick up address"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, move_from_address: e.target.value})}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    required
                    id="move_from_city_id"
                    name="move_from_city"
                    label="City"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, move_from_city: e.target.value})}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    required
                    id="move_from_postcode_id"
                    name="move_from_postcode"
                    label="Zip / Postal code"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, move_from_postcode: e.target.value})}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    required
                    id="move_from_country_id"
                    name="move_from_country"
                    label="Country"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, move_from_country: e.target.value})}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    id="move_on_id"
                    name="move_on"
                    label="Moving date"
                    type="datetime-local"
                    format="MM/dd/yyyy"
                    onChange={e => setAuctionInfo({...auctionInfo, move_on: e.target.value})}
                    InputLabelProps={{
                    shrink: true,
                    }}
                />
            </Grid>

            {/******************  DELIVERY DETAILS  ****************************/}
            <Grid item xs={12}>
                <Typography variant="body2">
                Delivery Details
                </Typography>
                <TextField
                    required
                    value={auctionInfo.move_to_address}
                    id="move_to_address_id"
                    name="move_to_address"
                    label="Delivery address"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, move_to_address: e.target.value})}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    required
                    id="move_to_city_id"
                    name="move_to_city"
                    label="City"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, move_to_city: e.target.value})}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    required
                    id="move_to_postcode_id"
                    name="move_to_postcode"
                    label="Zip / Postal code"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, move_to_postcode: e.target.value})}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    required
                    id="move_to_country_id"
                    name="move_to_country"
                    label="Country"
                    fullWidth
                    onChange={e => setAuctionInfo({...auctionInfo, move_to_country: e.target.value})}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextField
                    fullWidth
                    id="deliver_on_id"
                    name="deliver_on"
                    label="Delivery date"
                    type="datetime-local"
                    format="MM/dd/yyyy"
                    onChange={e => setAuctionInfo({...auctionInfo, deliver_on: e.target.value})}
                    InputLabelProps={{
                    shrink: true,
                    }}
                />
            </Grid>

            {/*********************************************************************/}
        </Grid>
        </>
    );
}